// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Home from './pages/home';
import Birthday from './pages/birthday';
import './styles/normalize.css';
function App() {
  return (
    <Router>
      <Routes>
        {/* Redireciona a raiz (/) para o componente Home */}
        <Route path="/" element={<Home />} />
        <Route path='/birthday' element={<Birthday />} />
        {/* Redireciona qualquer rota não existente para a raiz (/) */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
